import { TranscriptFragmentRole } from "@repo/app-types/entities/transcriptFragment";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";
import { ShareFragmentIconButton } from "../interviews/interviewSlideover/shareFragmentIconButton.js";
import { TextWithHighlight } from "./textWithHighlight.js";

interface TranscriptFragmentTextProps {
  text: string | null;
  role: TranscriptFragmentRole | null;
  highlightedText?: string;
  isHighlighted?: boolean;
  className?: string;
  onClickShare?: () => void;
}

export const TranscriptFragmentText: FC<TranscriptFragmentTextProps> = ({
  text,
  role,
  isHighlighted,
  highlightedText,
  className,
  onClickShare,
}) => {
  if (!text) return null;

  // Display agent transcript with less emphasis
  if (role === TranscriptFragmentRole.AGENT) {
    return (
      <div className={twMerge("mt-2 mb-2 text-sm text-foreground", className)}>
        {text}
      </div>
    );
  }

  return (
    <div className="block">
      <div
        className={twMerge(
          "group relative inline-block rounded-sm px-2 py-1 transition-colors duration-200 ease-in-out",
          isHighlighted ? "bg-amber-300" : "bg-amber-50",
          className,
        )}
      >
        <TextWithHighlight text={text} highlight={highlightedText} />
        {onClickShare && (
          <div
            className="absolute top-1/2 right-1 mr-1 -translate-y-1/2 transform opacity-0 group-hover:opacity-100"
            onClick={(e) => e.stopPropagation()}
          >
            <ShareFragmentIconButton onClick={onClickShare} />
          </div>
        )}
      </div>
    </div>
  );
};
